import React from 'react'
import { Box, Container, Typography } from '@mui/material'

export default function Home() {
  return (
    <Container maxWidth="md">
      <Box sx={{ mt: 8, textAlign: 'center' }}>
        <Typography variant="h3" component="h1" gutterBottom>
          Okonomi HV
        </Typography>
        <Typography variant="body1" color="text.secondary">
          Hausverwaltung application
        </Typography>
      </Box>
    </Container>
  )
}
